<div class="charges-page content-without-footer d-flex me-0 ms-0">
    <router-outlet class="position-absolute"></router-outlet>
</div>
